// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d266d974","453":"ae507ee8","455":"56ace001","977":"1ed50933"}[chunkId] + ".chunk.js";
};